<template>
  <div>
    <div class="row justify-content-center display-grid">
      <span class="strong"> {{ $t('inserdepositvalue') }} </span>
      <fg-input style="width: 25rem;"
        v-model="amountToDeposit"
        type="number"
        :min="0"
        controls-position="right"
        size="large"
      >
      </fg-input>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-10 alert alert-info">
        <i class="fa fa-info-circle mr-2 "></i>
        <span> {{ taxesInfo }} </span>
      </div>
    </div>
    <div class="row justify-content-center display-grid">
      <span class="strong"> {{ $t('amount_charged') }} </span>
      <el-input
        style="width: 25rem;"
        v-model="amountCharged"
        disabled
        class="bigger-symbol text-center">
        <template #prepend>{{ selectedCurrency.toUpperCase() }}</template>
      </el-input>
    </div>
    <!-- Button -->
    <div class="row justify-content-center display-grid mt-4">
      <div v-if="!paypalValueConfirmed">
        <p-button type="success" v-on:click="confirmValuePayPal()">
          {{ $t('confirm') }}
        </p-button>
      </div>
    </div>
    <div class="col-md-12 mt-3" v-if="paypalValueConfirmed">
      <div id="divpaypal" ref="paypal"></div>
    </div>
  </div>
</template>
<script>
import {Input, Option, Select, Tooltip} from "element-ui";
import swal from "sweetalert2";
const user_data = JSON.parse(localStorage.getItem('user-info'));

export default {
  name: "paypalMethod",
  components: {
    [Input.name]: Input,
  },
  data() {
    return {
      txt: {
        paypal: {
          value: this.$t('deposit_value')
        },
      },
      amountToDeposit: 0,
      amountCharged: 0,
      client_id: 'AXil5553QeFifz2yVy7UC3z5MmtRh7waZyheAo0sxfMOzOl6469kCdrDyDVbmein4hVfANlriW0kMXz4',
      paypalValueConfirmed: false,
      userid: user_data.email,
      paypalAlertMsg: '',
      typeMsg: '',
      methodList: [
        {
          label: '(EUR) Euro',
          currency: 'eur',
          symbol: '€',
          type: 'paypal',
          label: 'PAYPAL',
          percentFee: 0.045,
          fixedFee: 0.35,
        },
        {
          label: '(USD) American Dollar',
          currency: 'usd',
          symbol: '$',
          type: 'paypal',
          label: 'PAYPAL',
          percentFee: 0.061,
          fixedFee: 0.30,
        }
      ],
      percentFee: 0,
      fixedFee: 0,
      exchangeRates: [],
    }
  },
  props: {
    selectedCurrency: {type: String},
  },
  computed: {
    taxesInfo: {
      get(){
        return this.$t('methodCharge', ['PayPal', this.getPercentage()])}
      }
  },
  methods: {
    toLowerCaseKeys(obj) {
      if (typeof obj !== "object" || obj === null) return obj;

      if (Array.isArray(obj)) {
        return obj.map(this.toLowerCaseKeys);
      }

      return Object.keys(obj).reduce((acc, key) => {
        acc[key.toLowerCase()] = this.toLowerCaseKeys(obj[key]);
        return acc;
      }, {});
    },
    getPercentage() {
      return "$" + parseFloat(this.fixedFee).toFixed(2) +
        " + "+  parseFloat(this.percentFee * 100).toFixed(2) +"% ";
    },
    loadPayPal() {
      if (document.getElementById('pcc')) {
        document.getElementById('pcc').remove()
      }
      const script = document.createElement("script");
      script.id = 'pcc'
      const currency = this.selectedCurrency.toUpperCase();
      script.src = "https://www.paypal.com/sdk/js?currency=" + currency + "&client-id=" + this.client_id;
      script.addEventListener("load", () => {
        this.setLoaded({
          handler: this.responseHandler,
          getValue: () => {
            return parseFloat(this.amountCharged).toFixed(2);
          }
        });
      });
      document.body.appendChild(script);
    },
    setLoaded: function ( params ) {
      if (!document.getElementById('pcc')) {
        return
      }
      window.paypal.Buttons({
        style: {
          layout: 'horizontal',
          size: 'small',
          color: 'gold',
          shape: 'rect',
        },
        createOrder: function(data, actions) {
          return actions.order.create({
            purchase_units: [{
              amount: {
                value: params.getValue(),
              }
            }],
            application_context: {
              shipping_preference: 'NO_SHIPPING'
            }
          });
        },
        onApprove: function(data, actions) {
          return actions.order.capture()
            .then(params.handler)
        }
      }).render(this.$refs.paypal);
    },
    responseHandler(details) {
      if (details.status == 'VOIDED') {
        // status 4
        this.paypalAlertMsg = this.$t('paypalwentwrong_external')
        this.typeMsg = 'warning';
        this.responseNotification()
        return;
      }

      this.$paypalUserConfirm({
        userid: this.userid,
        value: this.amountToDeposit,
        currency: this.selectedCurrency,
        exchange_rate: (this.selectedCurrency == 'eur' ? parseFloat(this.exchangeRates.eur) : parseFloat(this.exchangeRates.brl) ) + 0.01,
        paypal_response: details,
      }).then(this.confirmationHandler, this.errorHandler)
    },
    confirmationHandler(response) {
      if (response.success) {
        this.typeMsg = 'success';
        this.paypalAlertMsg = this.$t('paypalrequestconfirmed')
      } else {
        this.paypalAlertMsg = this.$t('paypalwentwrong_internal');
        this.typeMsg = 'warning'
      }
      this.responseNotification()
    },
    errorHandler() {
      this.paypalAlertMsg = this.$t('paypalwentwrong_internal');
      this.typeMsg = 'warning'
      this.responseNotification()
    },
    confirmValuePayPal() {
      if (this.amountToDeposit == 0) {
        return this.$toast.warning(this.$t('inserdepositvalue'))
      } else {
        this.paypalValueConfirmed = true
        this.loadPayPal()
      }
    },
    responseNotification() {
      swal({
        title: this.$t('paywithpaypal'),
        text: this.paypalAlertMsg,
        type: this.typeMsg,
        allowOutsideClick: false,
        allowEscapeKey: false
        }
      )
    },
    loadExchangeRates(resp) {
      if (resp.success) {
        this.exchangeRates = this.toLowerCaseKeys(resp.data)
      }
    },
    failExchangeRates(resp){
      console.error(resp)
    },
  },
  created() {
      let tempAux = this.methodList.find( el => el.currency == this.selectedCurrency)
      this.percentFee = tempAux.percentFee
      this.fixedFee = tempAux.fixedFee
      this.$getExchangeRates().then(this.loadExchangeRates, this.failExchangeRates);
  },
  watch: {
    'amountToDeposit': function (newVal) {
      newVal = parseFloat(newVal)
      if (newVal === 0 || newVal <= 0 || !newVal) {
        return this.amountCharged = 0
      }
      if (this.selectedCurrency == 'eur') {
        let aux = newVal * parseFloat(parseFloat(this.exchangeRates.eur).toFixed(2));
        newVal = (( aux + this.fixedFee) + (aux * this.percentFee)).toFixed(2)
      }
      if (this.selectedCurrency == 'usd') {
        newVal = ((newVal + this.fixedFee) + (newVal * this.percentFee )).toFixed(2);
      }
      this.amountCharged = newVal;
    },
  }
}
</script>
<style scoped>

</style>
